import './index.css';
import { jsx } from 'react/jsx-runtime';
import { Fragment } from 'react';
import classnames from 'classnames';
import { Breakpoint } from '@hh.ru/magritte-ui-breakpoint';
import { Card } from '@hh.ru/magritte-ui-card';
import { Cell, CellText } from '@hh.ru/magritte-ui-cell';
import { CustomChip } from '@hh.ru/magritte-ui-chips';
import { Text } from '@hh.ru/magritte-ui-typography';

var styles = {"chips-section-container":"magritte-chips-section-container___Z7N-E_8-0-4","chipsSectionContainer":"magritte-chips-section-container___Z7N-E_8-0-4","chips-section-container_with-other-items":"magritte-chips-section-container_with-other-items___eJZAr_8-0-4","chipsSectionContainerWithOtherItems":"magritte-chips-section-container_with-other-items___eJZAr_8-0-4","suggest-items-container":"magritte-suggest-items-container___SKj-g_8-0-4","suggestItemsContainer":"magritte-suggest-items-container___SKj-g_8-0-4","suggest-items-container-wrapper":"magritte-suggest-items-container-wrapper___T2L5U_8-0-4","suggestItemsContainerWrapper":"magritte-suggest-items-container-wrapper___T2L5U_8-0-4","suggest-input-container":"magritte-suggest-input-container___l3OkM_8-0-4","suggestInputContainer":"magritte-suggest-input-container___l3OkM_8-0-4","bottom-sheet-input-hide-caret":"magritte-bottom-sheet-input-hide-caret___ikoig_8-0-4","bottomSheetInputHideCaret":"magritte-bottom-sheet-input-hide-caret___ikoig_8-0-4","error-wrapper":"magritte-error-wrapper___Ui4xt_8-0-4","errorWrapper":"magritte-error-wrapper___Ui4xt_8-0-4"};

const RenderItemDefault = ({ type, data, item, onValueSelect, 'data-qa': dataQa, }) => {
    if (type === 'cells') {
        return (jsx(Cell, { children: jsx(CellText, { children: data?.text || item.value }) }));
    }
    if (type === 'chips') {
        return (jsx(CustomChip, { onMouseDown: (event) => event.preventDefault(), onClick: () => onValueSelect(item.value, item.data), "data-qa": dataQa, children: item.value }));
    }
    return null;
};
const renderSection = (section, sectionId, onValueSelect, breakpoint, length, haveBottomContent, renderItem = RenderItemDefault) => {
    if (section.type === 'cells') {
        const cellsSection = section;
        return cellsSection.items.map((item) => {
            return (jsx(Card, { style: "primary", stretched: true, hoverStyle: "secondary", onMouseDown: (event) => {
                    event.preventDefault();
                }, onClick: (event) => {
                    event.preventDefault();
                    onValueSelect(item.value, item.data);
                }, padding: [Breakpoint.XS, Breakpoint.S].includes(breakpoint) ? 0 : 12, paddingTop: 12, paddingBottom: 12, borderRadius: 12, "data-qa": "suggest-item-cell", children: renderItem({
                    type: section.type,
                    item,
                    data: item.data,
                    onValueSelect,
                    breakpoint,
                    'data-qa': 'suggest-item-cell-text',
                }) }, `cell_${sectionId}_${item.value}`));
        });
    }
    if (section.type === 'chips') {
        const chipsSection = section;
        return [
            jsx("div", { className: classnames(styles.chipsSectionContainer, {
                    // чипсы - не последний элемент или есть нижний контент
                    [styles.chipsSectionContainerWithOtherItems]: sectionId !== length - 1 || haveBottomContent,
                }), children: chipsSection.items.map((item) => {
                    return (jsx(Fragment, { children: renderItem({
                            type: section.type,
                            item,
                            data: item.data,
                            onValueSelect,
                            breakpoint,
                            'data-qa': 'suggest-item-chips',
                        }) }, `chips_${sectionId}_${item.value}`));
                }) }, `chips_section_${sectionId}`),
        ];
    }
    if (section.type === 'delimiter') {
        const delimiterSection = section;
        return [
            jsx(Card, { style: "primary", stretched: true, padding: [Breakpoint.XS, Breakpoint.S].includes(breakpoint) ? 0 : 12, paddingTop: 8, paddingBottom: 8, "data-qa": "suggest-item-delimiter", children: jsx(Text, { style: "secondary", typography: "label-3-regular", children: delimiterSection.text }) }, `delimiter_${delimiterSection.text}`),
        ];
    }
    return [];
};

export { RenderItemDefault as R, renderSection as r, styles as s };
//# sourceMappingURL=sectionRenderers-DUEbkI2e.js.map
